export interface MonthlyReportRecipient {
  id: string;
  language: string;
  email: string;
}

export interface MonthlyReportReportRecipient {
  id: string;
  email: string;
}

export interface MonthlyReportLanguageReport {
  id: string;
  status: string;
  errorMessage: string | null;
  fileUrl: string | null;
}

export interface MonthlyReportRow {
  monthlyReportDataId: string;
  accountId: string;
  language: string;
  recipients: MonthlyReportReportRecipient[];
  report: MonthlyReportLanguageReport | null;
}

export interface MonthlyReport {
  id: string;
  account: { id: string; name: string };
  monthlyReportDataId: string;
  partner?: string;
  fileUrl?: string;
  date: string;
  data: Record<string, unknown>;
  template: { id: string; name: string };
  reports: MonthlyReportRow[];
}

export interface MonthlyReportsQueryParams {
  limit: number;
  skip: number;
  sort?: string;
  date: string;
  accountId?: string;
  accountName?: string;
  partner?: string;
}

export interface MonthlyReportsApiResponse {
  total: number;
  limit: number;
  skip: number;
  data: MonthlyReport[];
}

export interface SendResult {
  reportId: string;
  language: string;
  recipientCount: number;
  sent: boolean;
  error?: string;
}

export interface SendSummary {
  sent: number;
  failed: number;
  error?: string;
  results: SendResult[];
}

export interface MonthlyReportsState {
  reports: MonthlyReport[];
  total: number;
  limit: number;
  skip: number;
  hiddenColumns: string[];
  status: 'init' | 'loading' | 'loaded';
}

export enum MonthlyReportsActionTypes {
  GET_MONTHLY_REPORTS_REQUEST = 'esmiley/monthly-reports/GET_MONTHLY_REPORTS_REQUEST',
  GET_MONTHLY_REPORTS = 'esmiley/monthly-reports/GET_MONTHLY_REPORTS',
  GET_MONTHLY_REPORTS_FAILURE = 'esmiley/monthly-reports/GET_MONTHLY_REPORTS_FAILURE',
  SEND_MONTHLY_REPORT_EMAIL_REQUEST = 'esmiley/monthly-reports/SEND_MONTHLY_REPORT_EMAIL_REQUEST',
  SEND_MONTHLY_REPORT_EMAIL_SUCCESS = 'esmiley/monthly-reports/SEND_MONTHLY_REPORT_EMAIL_SUCCESS',
  SEND_MONTHLY_REPORT_EMAIL_FAILURE = 'esmiley/monthly-reports/SEND_MONTHLY_REPORT_EMAIL_FAILURE',
  SET_MONTHLY_REPORTS_HIDDEN_COLUMNS = 'esmiley/monthly-reports/SET_MONTHLY_REPORTS_HIDDEN_COLUMNS'
}

type GetMonthlyReportsRequestAction = {
  type: MonthlyReportsActionTypes.GET_MONTHLY_REPORTS_REQUEST;
};

type GetMonthlyReportsAction = {
  type: typeof MonthlyReportsActionTypes.GET_MONTHLY_REPORTS;
  payload: MonthlyReportsApiResponse;
};

type GetMonthlyReportsFailureAction = {
  type: MonthlyReportsActionTypes.GET_MONTHLY_REPORTS_FAILURE;
};

type SendMonthlyReportEmailRequestAction = {
  type: MonthlyReportsActionTypes.SEND_MONTHLY_REPORT_EMAIL_REQUEST;
};

type SendMonthlyReportEmailSuccessAction = {
  type: MonthlyReportsActionTypes.SEND_MONTHLY_REPORT_EMAIL_SUCCESS;
};

type SendMonthlyReportEmailFailureAction = {
  type: MonthlyReportsActionTypes.SEND_MONTHLY_REPORT_EMAIL_FAILURE;
};

type SetMonthlyReportsHiddenColumnsAction = {
  type: typeof MonthlyReportsActionTypes.SET_MONTHLY_REPORTS_HIDDEN_COLUMNS;
  payload: string[];
};

export type MonthlyReportsActions =
  | GetMonthlyReportsRequestAction
  | GetMonthlyReportsAction
  | GetMonthlyReportsFailureAction
  | SendMonthlyReportEmailRequestAction
  | SendMonthlyReportEmailSuccessAction
  | SendMonthlyReportEmailFailureAction
  | SetMonthlyReportsHiddenColumnsAction;
